import React from "react";
import { CircleCheckIcon, CreditCardIcon, MailIcon, ShieldCheckIcon } from "lucide-react";
import { PACK_IMAGE, heroHighlights } from "../data/content";
import { CtaButton } from "./CtaButton";

/**
 * En celular, el orden es: título → mockup → botón, todo dentro de la primera pantalla.
 * En escritorio: texto a la izquierda (título, copy, botón) y mockup a la derecha.
 */
export function Hero() {
  return <section id="inicio" className="bg-night pb-12 pt-3 text-white md:pb-20 md:pt-6" style={{
    background: "radial-gradient(ellipse at 85% 45%, #102456, transparent 55%), #101115"
  }} data-id="element-145" data-mp="128fq7kfogfw8">
      <div className="wrap mb-4 flex items-center justify-between gap-4 border-b border-white/10 pb-3 md:mb-14 md:pb-5" data-id="element-146" data-mp="s9zzhikkb8n9">
        <div className="leading-none" data-id="element-147" data-mp="nbyid36p5jef">
          <span className="block text-[22px] font-black tracking-[-1px] md:text-[28px]" data-id="element-148" data-mp="3d1a9nnfemhev">CNS</span>
          <span className="block text-[8px] font-medium tracking-[1.5px] text-haze md:text-[9px]" data-id="element-149" data-mp="382p4rap7j9k3">
            CELULARES NUEVOS SAAVEDRA
          </span>
        </div>
        <span className="whitespace-nowrap text-xs font-medium text-haze" data-id="element-150" data-mp="3j6fxfnpbn9cs">
          <span className="font-bold text-gold" data-id="element-151" data-mp="3o6amdlpjdov7">185K</span> en Instagram
        </span>
      </div>

      <div className="wrap grid items-center gap-x-14 gap-y-4 md:grid-cols-[1.15fr_1fr] md:gap-y-7" data-id="element-152" data-mp="399jq3lb5st9t">
        {/* Título */}
        <div className="text-center md:col-start-1 md:row-start-1 md:text-left" data-id="element-153" data-mp="3ebiqcmblra2j">
          <div className="hidden items-center gap-2 rounded-full border border-gold/50 bg-gold/5 px-4 py-2 text-[11px] font-bold uppercase tracking-[2px] text-gold md:inline-flex" data-id="element-154" data-mp="30ggg5mzq2yjx">
            <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden="true" data-id="element-155" data-mp="2ql6b0qe12b1x" />
            Celulares Nuevos Saavedra presenta
          </div>
          <p className="text-[10px] font-bold uppercase tracking-[2px] text-gold md:hidden" data-id="element-156" data-mp="2vglkl6505ksj">
            Celulares Nuevos Saavedra presenta
          </p>
          <h1 className="display-title mt-2 text-[clamp(34px,9.4vw,84px)] md:mt-6" data-id="element-157" data-mp="2ljgyf6b5ppbq">
            Sacá fotos y videos que hagan lucir <span className="text-gold" data-id="element-158" data-mp="s3cmgcr3vnrm">lo que vendés.</span>
          </h1>
        </div>

        {/* Mockup */}
        <figure className="mx-auto md:col-start-2 md:row-span-3 md:row-start-1 md:w-full md:max-w-[420px]" data-id="element-159" data-mp="n98dxp26z7of">
          <img src={PACK_IMAGE} width={1024} height={1536} alt="Pack Tu iPhone, Tu Estudio: libro principal y cinco bonos de CNS" className="mx-auto block h-[clamp(190px,36svh,330px)] w-auto md:h-auto md:w-full" data-id="element-160" data-mp="i9vp4yrrfqj7" />
          <figcaption className="mx-auto mt-4 hidden w-fit border border-gold/40 bg-forest px-4 py-2 text-[11px] font-bold uppercase tracking-[2px] text-gold md:block" data-id="element-161" data-mp="15zq1zgc2xf3g">
            De la cámara al catálogo
          </figcaption>
        </figure>

        {/* Botón + confianza */}
        <div className="md:col-start-1 md:row-start-3" data-id="element-162" data-mp="3luiaiu6w15my">
          <CtaButton href="#offer-details" data-id="element-163" data-mp="3hqu269afm60n">Quiero el pack completo</CtaButton>
          <ul className="mt-4 flex list-none flex-wrap justify-center gap-x-4 gap-y-1.5 p-0 text-[12px] text-haze md:mt-6 md:justify-start md:gap-x-5 md:text-[13px]" data-id="element-164" data-mp="1x9b3owgzwtag">
            <li className="flex items-center gap-1.5" data-id="element-165" data-mp="21bfxpwbcvrxm">
              <MailIcon className="h-3.5 w-3.5 text-gold md:h-4 md:w-4" aria-hidden="true" data-id="element-166" data-mp="269hci51r153a" />
              Envío inmediato por mail (PDF)
            </li>
            <li className="flex items-center gap-1.5" data-id="element-167" data-mp="2b2smug5rs3zy">
              <CreditCardIcon className="h-3.5 w-3.5 text-gold md:h-4 md:w-4" aria-hidden="true" data-id="element-168" data-mp="2g0luzeqmv82v" />
              Pago único de 27 USD
            </li>
            <li className="flex items-center gap-1.5" data-id="element-169" data-mp="2l0zycjhahtuk">
              <ShieldCheckIcon className="h-3.5 w-3.5 text-gold md:h-4 md:w-4" aria-hidden="true" data-id="element-170" data-mp="2p1jyzx12nflg" />
              Garantía de 10 días
            </li>
          </ul>
        </div>

        {/* Descripción */}
        <div className="mt-4 md:col-start-1 md:row-start-2 md:mt-0" data-id="element-171" data-mp="unrd141n9xwk">
          <p className="max-w-[560px] text-base text-haze md:text-lg" data-id="element-172" data-mp="zl11agdas3it">
            <strong className="text-white" data-id="element-173" data-mp="zndphb9nfa4b">Tu iPhone, Tu Estudio</strong> es la guía digital de CNS para usar la
            cámara de tu iPhone con intención: qué tocar, cómo iluminar y dónde ponerte, paso a paso.
          </p>
          <ul className="mt-4 flex list-none flex-wrap gap-x-4 gap-y-2 p-0 text-sm font-medium md:mt-6 md:gap-x-5 md:text-[15px]" data-id="element-174" data-mp="ea3fvbxtw06g">
            {heroHighlights.map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-175" data-mp="3hqaaksy9mn33">
                <CircleCheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-176" data-mp="3hqjz0c3nwm6o" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}